const resolveDefaultApiBaseUrl = () => {
    if (process.env.NODE_ENV !== 'development') {
        return '';
    }
    // In LAN dev setups the frontend is often accessed via IP (e.g. 10.x.x.x),
    // so `localhost` would point to the client machine, not the server.
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
        const host = window.location.hostname;
        return host === 'localhost' ? 'http://localhost:9090' : `http://${host}:9090`;
    }
    return 'http://localhost:9090';
};

const DEFAULT_API_BASE_URL = resolveDefaultApiBaseUrl();

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;
